module.exports = __webpack_public_path__ + "static/media/test4_4.a3181014.png";